var map = {
	"./dashboard.svg": 10570,
	"./example.svg": 57893,
	"./eye-open.svg": 81181,
	"./eye.svg": 28431,
	"./form.svg": 82962,
	"./link.svg": 49835,
	"./nested.svg": 83593,
	"./password.svg": 64117,
	"./table.svg": 85695,
	"./tree.svg": 79162,
	"./user.svg": 47798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;